import { createContext } from 'react';
const FetchProfileContext = createContext();
export default FetchProfileContext;